export default "__VITE_ASSET__B3H$$L0t__"